"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
exports.expressPropertyDefinition = expressPropertyDefinition;
const property_1 = require("@genesys/property");
const values_1 = require("../values");
// The steam side. Subcooling and superheat exist here as well as on the refrigerant side, but
// they are separate properties: what a steam coil subcools is condensate, and the two deserve
// their own wording rather than one label stretched over both.
/** What an express run walks: 0 = steam pressure, 1 = inlet temperature, 2 = inlet humidity. */
const steppingPressure = "stepproperty=0";
const notSteppingPressure = "stepproperty!=0";
function propertyDefinition() {
    return [
        {
            sort_no: 65,
            name: "pressure",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        ...condensate(property_1.PropertyFilter.Empty)
    ];
}
function expressPropertyDefinition() {
    return [
        {
            sort_no: 64,
            name: "pressure",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            // A run that steps the pressure gets the min/max/step triple instead of a single value.
            visibility_filter: (0, values_1.filter)(notSteppingPressure),
            value: []
        },
        ...["min", "max", "step"].map((suffix, i) => ({
            sort_no: 65 + i,
            name: `pressure${suffix}`,
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: (0, values_1.filter)(steppingPressure),
            value: []
        })),
        ...condensate(property_1.PropertyFilter.Empty)
    ];
}
function condensate(visibility) {
    return [
        {
            sort_no: 90,
            name: "subcoolingtemp",
            group: "",
            quantity: "DeltaTemperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: visibility,
            value: []
        },
        {
            sort_no: 100,
            name: "superheattemp",
            group: "",
            quantity: "DeltaTemperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: visibility,
            value: []
        }
    ];
}
//# sourceMappingURL=input-definition.js.map